import Color from 'color'
import { View } from 'react-native'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { TextTable } from '../atoms'
import React from 'react'
import { commonColors } from '@linqpal/common-frontend/src/theme'

/**
 * @param props
 * @param props.label
 * @param props.content - Instead of children (For easier string passing)
 * @param props.contentStyle
 * @param props.children
 * @returns {JSX.Element}
 * @constructor
 */
export const SidebarDetailItem = ({
  style,
  label,
  content,
  contentStyle,
  children,
  bold,
  inactive = false,
  testID,
}: {
  style?: any
  label?: any
  content?: any
  contentStyle?: any
  children?: any
  bold?: any
  inactive?: boolean
  testID?: string
}) => {
  const borderBottomColor = Color(commonColors.borderLight)
    .alpha(0.6)
    .rgb()
    .string()

  const textStyle = inactive
    ? { color: commonColors.tertiaryLighter }
    : undefined

  return (
    <View
      style={composeStyle(
        {
          flexDirection: 'row',
          borderBottomWidth: 1,
          borderBottomColor,
          paddingVertical: 12,
        },
        style,
      )}
      testID={testID || `${label}_item`}
    >
      <TextTable width={250} style={textStyle}>
        {label}
      </TextTable>
      <TextTable
        style={[contentStyle, textStyle]}
        fontWeight={bold ? 'bold' : '400'}
      >
        {content}
      </TextTable>
      {children}
    </View>
  )
}
